const Graph = {
    init: function () {
        this.adjList = {};
    },
    vertexExists: function (vertexName) {
        return this.adjList[vertexName] ? true : false;
    },
    addVertex: function (name) {
        try {
            if (name === '' || name === undefined) return;
            if (this.vertexExists(name)) throw (`addVertex Error: Vertex '${name}' already exists.`);
            this.adjList[name] = [];
        } catch (e) {
            console.error(e);
            throw e;
        }
        return this;
    },
    addEdge: function (v1, v2) {
        try {
            if (!this.vertexExists(v1)) throw (`addEdge error: Vertex '${v1}' does not exist.`);
            if (!this.vertexExists(v2)) throw (`addEdge error: Vertex '${v2}' does not exist.`);
            if (!this.adjList[v1].includes(v2)) this.adjList[v1].push(v2);
            if (!this.adjList[v2].includes(v1)) this.adjList[v2].push(v1);
        } catch (e) {
            console.error(e);
            throw e;
        }
        return this;
    },
    removeVertex: function (name) {
        try {
            if (name === '' || name === undefined) return;
            if (!this.vertexExists(name)) throw (`removeVertex Error: Vertex '${name}' does not exist.`);
            let otherVertex;
            while (this.adjList[name].length) {
                otherVertex = this.adjList[name].pop();
                this.removeEdge(name, otherVertex);
            }
            delete this.adjList[name];
        } catch (e) {
            console.error(e);
            throw e;
        }
        return this;
    },
    removeEdge: function (v1, v2) {
        try {
            if (!this.vertexExists(v1)) throw (`removeEdge error: Vertex '${v1}' does not exist.`);
            if (!this.vertexExists(v2)) throw (`removeEdge error: Vertex '${v2}' does not exist.`);
            this.adjList[v1] = this.adjList[v1].filter(v => v !== v2);
            this.adjList[v2] = this.adjList[v2].filter(v => v !== v1);
        } catch (e) {
            console.error(e);
            throw e;
        }
        return this;
    },

    // Return true if two verticies are adjacent
    // v1 is the source vertex. v2 is vertex being checked: If v2 is in v1's adjacency list, return true; otherwise return false
    areAdjacent: function (v1, v2) {
        try {
            if (!this.vertexExists(v1)) throw (`areAdjacent error: Vertex '${v1}' does not exist.`);
            if (!this.vertexExists(v2)) throw (`areAdjacent error: Vertex '${v2}' does not exist.`);
            return this.adjList[v1].includes(v2);
        } catch (e) {
            console.error(e);
            throw e
        }
    },

    // Return array of all verticies 
    getAllVerticies: function () {
        return Object.keys(this.adjList);
    },

    // For a given vertex, return its adjacent verticies as an array, even if the array is empty 
    getAdjacentVerticies: function (v) {
        try {
            if (!this.vertexExists(v)) throw (`getAdjacentVerticies error: Vertex '${v}' does not exist.`);
            return this.adjList[v];
        } catch (e) {
            console.error(e);
            throw e
        }
    },

    // For a given vertext, get its adjacent verticies. If there's at least one, return true. If there are none, return false.
    hasAdjacentVerticies: function (v) {
        try {
            if (!this.vertexExists(v)) throw (`hasAdjacentVerticies error: Vertex '${v}' does not exist.`);
            return this.getAdjacentVerticies(v).length;
        } catch (e) {
            console.error(e);
            throw e
        }
    },

    BFS: function (vertex, resultCB) {
        if (typeof resultCB !== 'function') {
            resultCB = function (res, vertex) {
                res.push(vertex);
            }
        }
        try {
            if (vertex === '' || vertex === undefined) throw (`BFS Error: Starting vertex must be specified.`);
            if (!this.vertexExists(vertex)) throw (`BFS Error: Vertex '${vertex}' does not exist.`);
            const queue = [vertex];
            const result = [];
            const visited = {};
            let currentVertex;
            visited[vertex] = true;
            // console.log(resultCB);
            while (queue.length) {
                currentVertex = queue.shift();
                resultCB(result, currentVertex);
                // result.push(currentVertex);
                this.adjList[currentVertex].forEach(neighbor => {
                    if (!visited[neighbor]) {
                        visited[neighbor] = true;
                        queue.push(neighbor);
                    }
                });
            }
            return result;
        } catch (e) {
            console.error(e);
        }
    }

}




function newGraph() {
    const g = Object.create(Graph);
    g.init();
    return g;
}

export { newGraph }